import type L from "leaflet";
import { CanvasPinRenderer } from "./CanvasPinRenderer";

const renderers = new WeakMap<L.Map, CanvasPinRenderer>();

/**
 * 地図ごとに1つの CanvasPinRenderer を返す。
 *
 * ピンの種類（保存した物件リスト・検索結果など）ごとにレンダラを分けると、canvas が
 * 種類の数だけ重なり、クリックも種類ごとに判定されて重なったピンの両方が反応する。
 * 1つにまとめると、どの種類のピンも描いた順に重なり、一番上のピンだけがクリックを受け取る。
 */
export const getSharedCanvasPinRenderer = (map: L.Map): CanvasPinRenderer => {
  let renderer = renderers.get(map);
  if (!renderer) {
    renderer = new CanvasPinRenderer({ pane: "markerPane", padding: 0.1 });
    renderers.set(map, renderer);
  }
  return renderer;
};
